/**
 * Created by Apple on 16/11/18.
 */

var fix_adplus = function (url, opts) {
    if (/imp\.optaim.com|clk.optaim\.com|trackimp/ig.test(url)) {
        if (url.indexOf("?") > 0) {
            return url + "&apid=" + (opts && opts.apid) + "&impid=" + (opts && opts.impid);
        } else {
            return url + "?apid=" + (opts && opts.apid) + "&impid=" + (opts && opts.impid);
        }
    }
    return url;
}
export default {
    //
    fix_imp_str: function (val, opts) {
        var r = []
        if (val) {

            if (val instanceof Array) {
                for (var i = 0; i < val.length; i++) {
                    r.push(fix_adplus(val[i], opts));
                }
            } else if (typeof(val) === "string") {
                if (val.indexOf("[") == 0) {
                    try {
                        var imp_list = JSON.parse(val);
                        for (var i = 0; i < imp_list.length; i++) {
                            if (imp_list[i]) {
                                r.push(fix_adplus(imp_list[i], opts));
                            }
                        }
                    } catch (e) {

                    }
                } else {
                    var imp_list = val.split("|");
                    for (var i = 0; i < imp_list.length; i++) {
                        if (imp_list[i]) {
                            r.push(fix_adplus(imp_list[i], opts));
                        }
                    }
                }
            }
        }
        return r;
    },
    fix_adplus: fix_adplus
};